<template>
  <div>
    <v-dialog v-model="dialog" width="1200" persistent>
      <v-card class="rounded-lg">
        <template>
          <v-container fluid class="pt-2 pb-4" style="height: 280px">
            <v-row v-show="startLoadingAudio" style="display: flex; justify-content: center">
              <v-col class="pt-4 mt-8" cols="12" style="display: flex; justify-content: center">
                <span>{{ "Loading audio file...." }}</span>
              </v-col>
              <v-col class="pt-0 pl-10 pr-10" cols="12" style="display: flex; justify-content: center">
                <v-progress-linear class="ml-3 mr-3" v-model="power" color="#4FB14E" height="10"></v-progress-linear>
              </v-col>
            </v-row>
            <v-row v-show="showMp3Player" no-gutters class="mb-2">
              <v-col class="py-0 pr-1" style="display: flex; justify-content: end">
                <v-btn icon @click="closeSoundDialog" color="#424242" style="
                    border-radius: 8px !important;
                    width: 30px !important;
                    height: 30px !important;
                  ">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="d-flex" no-gutters>
              <v-col cols="12" lg="8" md="8" sm="12" class="border pl-2" v-show="showMp3Player">
                <v-row>
                  <v-col cols="12" md="8" lg="8" sm="12" class="py-0">
                    <p class="mb-0 audioTitle-font">
                      {{ cutText() }}
                      <v-icon :color="Addfav ? '#FF6060' : ''" @click="toggleCheck" class="heart-icon">{{ heartIcon
                        }}</v-icon>
                    </p>

                    <p class="mb-0" style="font-size: 18px; color: #424242; opacity: 0.6">
                      {{ audioDescription }}
                    </p>
                  </v-col>
                  <v-col cols="12" md="4" lg="4" sm="12" class="py-0" style="text-align: end !important">
                    <v-btn class="play-back-btn" :disabled="disablePrevious">
                      <v-icon @click="playPreviousSound()" class="mr-2"
                        style="font-size: 32px; background-color: transparent"
                        color="#A6CC39">mdi-skip-previous</v-icon>
                    </v-btn>
                    <v-icon v-if="!showPlay" @click="pauseAudio" class="mr-2" style="font-size: 60px"
                      color="#A6CC39">mdi-pause-circle</v-icon>

                    <v-icon v-if="showPlay" @click="playAudio" class="mr-2" style="font-size: 60px"
                      color="#A6CC39">mdi-play-circle</v-icon>
                    <v-btn class="play-next-btn" :disabled="disableNext">
                      <v-icon @click="playNextSound()" class="mr-2" style="font-size: 32px"
                        color="#A6CC39">mdi-skip-next</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row no-gutters> </v-row>
                <v-row>
                  <v-col>
                    <div id="waveform"></div>
                    <v-row>
                      <v-col>
                        <span>{{ currentAudioTime }}</span>
                      </v-col>
                      <v-col style="
                          align-items: flex-end;
                          display: flex;
                          justify-content: end;
                        ">
                        <span class="mr-4">{{ audioDuration }}</span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-1">
                      <div v-if="showAlertMessage" style="color: red; font-weight: bold">
                        {{ $t("soundfilenotrewinded") }}
                      </div>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col v-show="showMp3Player" class="border" cols="12" lg="4" md="4" sm="12" style="
                  display: flex;
                  padding: 0px 7px 5px 20px;
                  justify-content: center;
                ">
                <v-img :src="audioImg" class="audioPhoto"></v-img>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template>
          <v-card v-show="showMp3Player" width="100%">
            <div class="scrollbar-container">
              <div class="video-scrollbar">
                <v-card-title class="pt-2 pb-2 videoTitle-font">
                  {{ audioName }}
                </v-card-title>

                <v-row no-gutters class="">
                  <v-col cols="12" class="pl-3" style="
                      display: flex;
                      justify-content: center;
                      vertical-align: middle;
                    ">
                    <v-avatar size="45" class="marginRight-6">
                      <v-img v-if="profileImg === null" src="@/assets/defaultprofile.png"></v-img>
                      <v-img v-else :src="profileImg"></v-img>
                    </v-avatar>
                    <v-text-field v-model="new_comment" :label="$t('writeacomment')" outlined
                      @input="checkCommentLength(new_comment, 1)" dense class="mt-1 comment-textbox" hide-details="auto"
                      maxlength="100"></v-text-field>
                  </v-col>
                  <v-col cols="12" class="py-3" style="display: flex; justify-content: end">
                    <v-btn depressed text outlined class="text-capitalize ml-5" style="
                        border-radius: 8px;
                        font-size: 14px;
                        width: 80px;
                        height: 35px;
                        margin-left: 5px;
                      " @click="(new_comment = ''), (mainComNull = true)">
                      {{ $t("cancel") }}
                    </v-btn>
                    <v-btn depressed :disabled="mainComNull" class="text-capitalize btn_hover_effect ml-5" style="
                        border-radius: 8px;
                        font-size: 14px;
                        width: 80px;
                        height: 35px;
                        color: #ffff;
                      " color="#A6CC39" @click="AddNewComment()">
                      {{ $t("send") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <div class="comment-paddingLeft4">
                  <p class="mb-0" style="font-weight: bold; color: black">
                    {{ commentItems.length != 0 ? commentItems.length : "0" }}
                    {{ $t("comments") }}
                  </p>
                </div>
                <div class="comment-paddingLeft4 pt-3" v-for="(comment, index) in commentItems" :key="index">
                  <v-row no-gutters>
                    <!-- outer comment part -->
                    <v-col cols="11" md="11" style="display: flex">
                      <v-row no-gutters>
                        <v-col cols="11" style="display: flex; flex-direction: row">
                          <v-avatar justify="center" align="center" size="35" class="marginRight-6">
                            <v-img v-if="comment.profileImage" :src="comment.profileImage"></v-img>
                            <v-img v-else src="@/assets/defaultprofile.png"></v-img>
                          </v-avatar>
                          <!-- show comment/show edit text-box -->
                          <div class="d-flex flex-column" style="width: 100%">
                            <div v-if="!comment.editCommentFlag">
                              <p class="mb-1">
                                {{ comment.fullname }}
                                {{ comment.commentedTime }}
                                <br />
                                {{ comment.commentMessage }}
                              </p>
                            </div>
                            <!-- when edit comment show this -->
                            <div v-else>
                              <v-row no-gutters>
                                <v-col cols="12" class="d-flex">
                                  <v-text-field :placeholder="$t('writeacomment')" dense v-model="comment.tempComment"
                                    @input="
                                      checkCommentLength(comment.tempComment, 2)
                                      " hide-details="auto" maxlength="100"></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row class="mt-0">
                                <v-col style="
                                    display: flex;
                                    justify-content: end;
                                    align-items: center;
                                  ">
                                  <v-btn depressed text outlined class="text-capitalize" style="
                                      border-radius: 8px;
                                      font-size: 14px;
                                      width: 80px;
                                      height: 35px;
                                    " @click="cancelComment(comment)">
                                    {{ $t("cancel") }}
                                  </v-btn>
                                  <v-btn depressed :disabled="commentNull" class="text-capitalize btn_hover_effect ml-5"
                                    style="
                                      border-radius: 8px;
                                      font-size: 14px;
                                      width: 80px;
                                      height: 35px;
                                      color: #ffff;
                                      padding: 0.3rem 0px 0.3rem 0px;
                                    " color="#A6CC39" @click="UpdateComment(comment)">
                                    {{ $t("update") }}
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </div>
                            <!-- reply btn under each comment -->
                            <div class="pt-1">
                              <v-btn style="
                                  font-size: 14px;
                                  min-width: 54px;
                                  min-height: 22px;
                                  height: auto !important;
                                  justify-content: center;
                                  background-color: #f0f0f0;
                                  color: #424242;
                                  opacity: 1;
                                  border-radius: 4px;
                                  padding: 0;
                                " text class="text-capitalize" @click="ClickCommentReply(comment)">
                                {{ $t("reply") }}
                              </v-btn>
                            </div>
                            <!-- show replies count text under reply btn -->
                            <div v-if="comment.replyCommentLists.length != 0" @click="showReplylist(comment)">
                              <p style="
                                  color: blue;
                                  cursor: pointer;
                                  font-size: 14px;
                                  text-transform: lowercase;
                                " class="mb-1">
                                <v-icon style="color: blue" v-if="comment.replyFlag">mdi-chevron-down</v-icon>
                                <v-icon v-else style="color: blue">mdi-chevron-up</v-icon>{{
                                  comment.replyCommentLists.length }}
                                {{
                                  comment.replyCommentLists.length > 1
                                    ? $t("replies")
                                    : $t("reply")
                                }}
                              </p>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <!-- dot actions for editing comments -->
                    <v-col v-if="
                      comment.memberID == loginmemberID ||
                      loginmemberID == memberID
                    " cols="1" md="1" class="px-0" style="display: flex; justify-content: end">
                      <template>
                        <div class="d-flex" style="margin-top: -5px">
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn text v-bind="attrs" v-on="on" style="
                                  min-width: 32px !important;
                                  padding: 0px !important;
                                ">
                                <v-icon style="color: #424242">mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>

                            <v-list class="d-flex flex-column align-start">
                              <div>
                                <v-list-item class="list-item-padding" v-show="loginmemberID == comment.memberID">
                                  <v-btn color="#424242" style="width: 100px; justify-content: left" text
                                    class="text-capitalize" @click="editComment(comment)">
                                    <v-icon left>mdi-square-edit-outline</v-icon>
                                    {{ $t("edit") }}
                                  </v-btn>
                                </v-list-item>
                                <v-list-item class="list-item-padding">
                                  <v-btn color="#FF6060" style="width: 100px; justify-content: left" text
                                    class="text-capitalize" @click="prepareDeleteComment(comment)">
                                    <v-icon left>mdi-delete-outline</v-icon>
                                    {{ $t("delete") }}
                                  </v-btn>
                                </v-list-item>
                              </div>
                            </v-list>
                          </v-menu>
                        </div>
                      </template>
                    </v-col>
                  </v-row>
                  <!-- reply text box to outer comment -->
                  <v-row no-gutters v-if="comment.showOuterCommentBox" class="mt-3">
                    <v-col cols="11" class="reply-textbox-paddingLeft d-flex flex-column">
                      <div class="d-flex" style="width: 100%">
                        <v-avatar class="marginRight-6" justify="center" align="center" size="40">
                          <v-img v-if="profileImg === null" src="@/assets/defaultprofile.png"></v-img>
                          <v-img v-else :src="profileImg"></v-img>
                        </v-avatar>
                        <div class="d-flex" style="width: 100%">
                          <v-text-field :placeholder="$t('writeareply')" v-model="comment.tempReplyMsg"
                            @input="checkCommentLength(comment.tempReplyMsg, 3)" class="comment-textbox" dense
                            hide-details="auto" maxlength="100"></v-text-field>
                        </div>
                      </div>
                      <div class="mt-3 d-flex justify-end" style="width: 100%">
                        <v-btn depressed text outlined class="text-capitalize ml-5" style="
                            border-radius: 8px;
                            font-size: 14px;
                            width: 80px;
                            height: 35px;
                            margin-left: 5px;
                          " @click="
                            (comment.tempReplyMsg = ''),
                            (mainComNull = true),
                            (comment.showOuterCommentBox = false)
                            ">
                          {{ $t("cancel") }}
                        </v-btn>
                        <v-btn depressed :disabled="replyCommentNull" class="text-capitalize btn_hover_effect ml-5"
                          style="
                            border-radius: 8px;
                            font-size: 14px;
                            width: 80px;
                            height: 35px;
                            color: #ffff;
                            padding: 0;
                          " color="#A6CC39" @click="AddReplyToComment(comment, null)">
                          {{ $t("reply") }}
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- replies of each related comment -->
                  <v-row class="mt-1 comment-paddingLeft4" v-for="(repcomment, repIndex) in comment.replyCommentLists"
                    :key="repIndex" v-show="comment.replyFlag">
                    <v-col cols="11" md="11" class="reply-textbox-paddingLeft d-flex flex-column pr-0">
                      <div class="d-flex" style="width: 100%">
                        <v-avatar class="marginRight-6" justify="center" align="center" size="35">
                          <v-img v-if="repcomment.profileImage" :src="repcomment.profileImage"></v-img>
                          <v-img v-else src="@/assets/defaultprofile.png"></v-img>
                        </v-avatar>
                        <div class="d-flex flex-column" style="width: 100%">
                          <p class="mb-0">
                            {{ repcomment.fullname }}
                            {{ repcomment.commentedTime }}
                          </p>
                          <div v-if="!repcomment.showInside_ReplyBox" style="display: flex; align-items: center">
                            <p style="color: #34b4eb; margin-right: 10px" class="mb-0">
                              {{ repcomment.replyFullname }}
                            </p>
                          </div>
                          <div v-if="!repcomment.showEditReplyBox" class="mb-2">
                            {{ repcomment.replyMessage }}
                          </div>
                          <div v-else>
                            <div>
                              <v-text-field :placeholder="$t('writeareply')" v-model="repcomment.tempEditReplyText"
                                @input="
                                  checkCommentLength(
                                    repcomment.tempEditReplyText,
                                    4
                                  )
                                  " class="comment-textbox" dense hide-details="auto" maxlength="100"></v-text-field>
                            </div>
                            <div class="mt-3 d-flex justify-end" style="width: 100%">
                              <v-btn depressed text outlined class="text-capitalize" style="
                                  border-radius: 8px;
                                  font-size: 14px;
                                  width: 80px;
                                  height: 35px;
                                " @click="
                                  () => {
                                    repcomment.showEditReplyBox = false;
                                    repcomment.tempEditReplyText = '';
                                  }
                                ">
                                {{ $t("cancel") }}
                              </v-btn>
                              <v-btn depressed :disabled="editReplyNull" class="text-capitalize btn_hover_effect ml-5"
                                style="
                                  border-radius: 8px;
                                  font-size: 14px;
                                  width: 80px;
                                  height: 35px;
                                  color: #ffff;
                                  padding: 0.3rem 0px 0.3rem 0px;
                                " color="#A6CC39" @click="UpdateReplyText(repcomment, comment)">
                                {{ $t("update") }}
                              </v-btn>
                            </div>
                          </div>
                          <div>
                            <v-btn style="
                                font-size: 14px;
                                min-width: 54px;
                                min-height: 22px;
                                height: auto !important;
                                justify-content: center;
                                background-color: #f0f0f0;
                                color: #424242;
                                opacity: 1;
                                border-radius: 4px;
                                padding: 0;
                              " text class="text-capitalize" v-if="!repcomment.showInside_ReplyBox"
                              @click="replyToInnerComment(repcomment)">
                              {{ $t("reply") }}
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <!-- dot action btns of inner reply comments -->
                    <v-col cols="1" md="1" class="px-0" style="display: flex; justify-content: end" v-if="
                      repcomment.memberID == loginmemberID ||
                      loginmemberID == memberID
                    ">
                      <template>
                        <div class="d-flex" style="margin-top: -5px">
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn text v-bind="attrs" v-on="on" class="mr-2" style="min-width: 32px !important">
                                <v-icon style="color: #424242">mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list class="d-flex flex-column align-start">
                              <div>
                                <v-list-item class="list-item-padding" v-show="loginmemberID == repcomment.memberID">
                                  <v-btn color="#424242" style="
                                      font-size: 16px;
                                      width: 100px;
                                      justify-content: left;
                                    " text class="text-capitalize" @click="
                                      editCommentReply(repcomment, comment)
                                      ">
                                    <v-icon left>mdi-square-edit-outline</v-icon>
                                    {{ $t("edit") }}
                                  </v-btn>
                                </v-list-item>
                                <v-list-item class="list-item-padding">
                                  <v-btn color="#FF6060" style="width: 100px; justify-content: left" text
                                    class="text-capitalize" @click="prepareDeleteReply(repcomment)">
                                    <v-icon left>mdi-delete-outline</v-icon>
                                    {{ $t("delete") }}
                                  </v-btn>
                                </v-list-item>
                              </div>
                            </v-list>
                          </v-menu>
                        </div>
                      </template>
                    </v-col>
                    <!-- inner reply box -->
                    <v-col cols="12" md="12" class="reply-textbox-paddingLeft" v-if="repcomment.showInside_ReplyBox"
                      style="display: flex; justify-content: center">
                      <v-row no-gutters>
                        <v-col cols="11" class="reply-textbox-paddingLeft d-flex flex-column">
                          <div class="d-flex" style="width: 100%">
                            <v-avatar class="marginRight-6" justify="center" align="center" size="40">
                              <v-img v-if="profileImg === null" src="@/assets/defaultprofile.png"></v-img>
                              <v-img v-else :src="profileImg"></v-img>
                            </v-avatar>
                            <div class="d-flex" style="width: 100%">
                              <v-text-field :placeholder="$t('writeareply')" v-model="repcomment.tempCommentReplyMsg"
                                @input="
                                  checkCommentLength(
                                    repcomment.tempCommentReplyMsg,
                                    5
                                  )
                                  " class="comment-textbox" dense hide-details="auto" maxlength="100"></v-text-field>
                            </div>
                          </div>
                          <div class="mt-3 d-flex justify-end" style="width: 100%">
                            <v-btn depressed text outlined width="80" height="35" class="text-capitalize ml-5"
                              style="border-radius: 8px; margin-left: 5px" @click="closeReplyMessage(repcomment)">
                              {{ $t("cancel") }}
                            </v-btn>
                            <v-btn depressed :disabled="replyInnerComNull" class="text-capitalize btn_hover_effect ml-5"
                              style="
                                border-radius: 8px;
                                font-size: 14px;
                                width: 80px;
                                height: 35px;
                                color: #ffff;
                                padding: 0;
                              " color="#A6CC39" @click="AddReplyToComment(comment, repcomment)">
                              {{ $t("reply") }}
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </v-card>
        </template>
      </v-card>
    </v-dialog>

    <v-dialog width="470" v-model="complete_dialog" persistent>
      <v-card style="overflow: hidden !important; border-radius: 16px !important">
        <v-card-title style="font-size: 20px; color: #363636">
          <v-row class="mt-1 mb-1">
            <v-col style="text-align: center">
              <p class="mb-2">{{ $t("confirmcomplete") }}</p>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions style="justify-content: center">
          <v-btn @click="viewComplete()" depressed color="#A6CC39"
            style="font-size: 16px; border-radius: 8px; width: 150px"
            class="text-capitalize white--text mb-2 mt-2 btn_hover_effect">{{ $t("confirm") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="470" v-model="exit_dialog" persistent>
      <v-card style="border-radius: 16px !important">
        <v-card-title style="font-size: 20px; color: #363636">
          <v-row>
            <v-col cols="12" md="10" lg="10" xl="10" class="pr-1 pl-1">
              <p class="mb-2">
                {{ $t("Soundnotfinish") }}
              </p>
            </v-col>
            <v-col cols="12" md="2" lg="2" xl="2" style="text-align: right" class="pr-1 pl-1">
              <v-btn icon @click="cancelExitPlayer()" color="#424242" class="mt-2" style="
                  border-radius: 8px !important;
                  border: 1px solid rgba(66, 66, 66, 0.05);
                  top: -8px;
                ">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="text-capitalize mb-2 mt-2" text style="
              border: 1px solid #c0c0c0;
              border-radius: 8px;
              color: #424242;
              font-size: 20px;
            " @click="cancelExitPlayer()">{{ $t("No") }}</v-btn>
          <v-btn color="#A6CC39" style="font-size: 20px; border-radius: 8px; width: 80px"
            class="text-capitalize white--text mb-2 mt-2 btn_hover_effect" @click="exitPlayer()">{{ $t("Yes") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delete_dialog" max-width="470px" max-height="87px" style="border-radius: 15px !important">
      <v-card style="border-radius: 15px !important">
        <v-spacer></v-spacer>
        <v-card-title class="flex justify-center items-center mb-4">
          <p class="mb-0" style="font-size: 20px; font-weight: bold">
            Delete Comment
          </p>
          <v-spacer></v-spacer>
          <v-btn icon @click="closemessageDialog()" color="#424242" style="
              border-radius: 8px !important;
              border: 1px solid rgba(66, 66, 66, 0.05);
            ">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="text-left">
          <p v-if="deleteType === 'comment'" style="font-size: 20px; color: #363636; opacity: 1" class="mb-1">
            Do you want to delete this comment?
          </p>
          <p v-else style="font-size: 20px; color: #363636; opacity: 1" class="mb-1">
            Do you want to delete this reply?
          </p>
        </v-card-text>
        <v-divider class="mb-2" style="opacity: 0.5"></v-divider>
        <v-card-actions class="justify-end" style="padding-bottom: 15px">
          <v-btn width="70" height="39" class="text-capitalize ml-5" style="border-radius: 8px; font-size: 14px"
            color="#F0F0F0 " @click="closemessageDialog()">{{ $t("No") }}</v-btn>
          <v-btn width="76" height="39" class="text-capitalize btn_hover_effect ml-5" style="
              color: #ffff;
              border: 1px solid #a6cc39;
              border-radius: 8px;
              font-size: 14px;
            " color="#A6CC39" @click="
              deleteType === 'comment'
                ? DeleteComment(deleteComTemp.commentID)
                : DeleteReply(deleteReplyTemp.replyID)
              ">{{ $t("Yes") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import WaveSurfer1 from "wavesurfer.js";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    viewerFlag: Boolean,
    audioName: String,
    audioDescription: String,
    audioImg: String,
    audioFile: String,
    contentid: Number,
    currentminutes: String,
    requestflag: Boolean,
    playListOpt: Object,
    memberID: String,
  },
  emits: [
    "close",
    "skipToPrevious",
    "skipToNext",
    "updateProgressCircle",
    "updateNotiReadStatusColor",
    "show_sound",
  ],
  data() {
    return {
      showAlertMessage: false,
      deleteReplyTemp: null,
      deleteComTemp: null,
      deleteType: null,
      delete_dialog: false,
      loginmemberID: localStorage.getItem("memberID"),
      new_comment: "",
      commentItems: [],
      commentNull: true,
      replyCommentNull: true,
      mainComNull: true,
      editReplyNull: true,
      replyInnerComNull: true,
      profileImg: localStorage.getItem("profileimage"),
      nextPrevFlag: false,
      disablePrevious: true,
      disableNext: true,
      showMp3Player: false,
      power: 0,
      startLoadingAudio: false,
      currentAudioTime: "0:00",
      audioDuration: "0:00",
      showPlay: false,
      wavesurfer: null,
      wavesurferOptions: {
        container: "#waveform",
        waveColor: "#eee", //#D2EDD4
        progressColor: "#A6CC39", //#46B54D
        cursorColor: "#424242",
        barHeight: 1,
        barRadius: 3,
        barWidth: 3,
        height: 95,
        responsive: true,
        origin: "*",
        backend: "MediaElement",
      },

      progress_time: 0,
      actualViewTime: 0,
      intervalId: 0,
      complete_dialog: false,
      confirmDialog: false,
      exit_dialog: false,
      Addfav: false,
      maxlength: 30,
      mediaActivityTimer: null, // F06 DSD
    };
  },
  watch: {
    playListOpt(obj) {
      this.disablePrevious = obj.previous === null;
      this.disableNext = obj.next === null;
    },
    audioFile(val) {
      setTimeout(() => {
        if (val) {
          this.PlayMP3(val);
        }
      }, 100);
    },
  },
  computed: {
    heartIcon() {
      return this.Addfav ? "mdi-heart" : "mdi-heart-outline";
    },
    dialog: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("close");
      },
    },
  },
  beforeDestroy() {
    this.stopMediaActivity(); // F06 DSD
  },
  methods: {
    //.......comment related..............................
    async DeleteReply(ID) {
      await axios
        .post(`${this.web_url}Comment/DeleteReplyComment?replyID=` + ID)
        .then((res) => {
          if (res.data.status == 0) {
            this.delete_dialog = false;
            this.GetCommentsForSound(this.contentid);
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    async DeleteComment(ID) {
      await axios
        .post(`${this.web_url}Comment/DeleteComment?CommentID=` + ID)
        .then((res) => {
          if (res.data.status == 0) {
            this.delete_dialog = false;
            this.deleteComTemp = null;
            this.GetCommentsForSound(this.contentid);
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    async UpdateReplyText(reply, comment) {
      this.editReplyNull = true;
      const request = {
        replyID: reply.replyID,
        replyMessage: reply.tempEditReplyText,
      };
      axios
        .post(`${this.web_url}Comment/UpdateReplyComment`, request)

        .then((result) => {
          if (result.data.status == 0) {
            comment.replyFlag = false;
            this.GetCommentsForSound(this.contentid);
          }
          this.commentNull = false;
        });
    },
    AddReplyToComment(item, reply) {
      this.replyCommentNull = true;
      this.replyInnerComNull = true;
      let tempReplyID = reply?.replyID || null;
      if (reply != null && reply.memberID == this.loginmemberID) {
        tempReplyID = null;
      }

      let tempReply_msg = reply?.tempCommentReplyMsg || "";
      const request = {
        userID: Number.parseInt(localStorage.getItem("UserID")),
        commentID: item.commentID,
        replyMessage: reply != null ? tempReply_msg : item.tempReplyMsg,
        replyID: tempReplyID,
      };
      axios
        .post(`${this.web_url}Comment/AddReplyComment`, request)

        .then((result) => {
          if (result.data.status == 0) {
            this.GetCommentsForSound(this.contentid);
          }
          this.commentNull = false;
        });
    },
    async UpdateComment(update_value) {
      this.commentNull = true;
      const request = {
        commentID: update_value.commentID,
        commentMessage: update_value.tempComment,
      };
      axios
        .post(`${this.web_url}Comment/UpdateComment`, request)

        .then((result) => {
          if (result.data.status == 0) {
            this.GetCommentsForSound(this.contentid);
          }
        });
    },
    AddNewComment() {
      this.mainComNull = true;
      const request = {
        companyID: localStorage.getItem("companyID"),
        userID: Number.parseInt(localStorage.getItem("UserID")),
        videoID: this.contentid,
        updateBy: null,
        createdBy: localStorage.getItem("memberID"),
        commentMessage: this.new_comment,
        Page: 4, //for sound page comment
      };
      axios
        .post(`${this.web_url}Comment/AddComment`, request)

        .then((result) => {
          if (result.data.status == 0) {
            this.GetCommentsForSound(this.contentid);
          }
        });
      this.new_comment = "";
    },
    prepareDeleteReply(repcomment) {
      this.deleteType = "reply";
      this.delete_dialog = true;
      this.deleteReplyTemp = repcomment;
    },
    closemessageDialog() {
      this.delete_dialog = false;
    },
    async prepareDeleteComment(comment) {
      this.delete_dialog = true;
      this.deleteComTemp = comment;
      this.deleteType = "comment";
    },
    closeReplyMessage(item) {
      item.showInside_ReplyBox = false;
      item.tempCommentReplyMsg = "";
      this.commentNull = false;
    },
    replyToInnerComment(repcomment) {
      this.commentItems.forEach((element) => {
        element.replyCommentLists.forEach((item) => {
          item.showInside_ReplyBox = false;
          item.showEditReplyBox = false;
          item.tempEditReplyText = "";
        });
      });
      repcomment.showInside_ReplyBox = true; //item.showOuterCommentBox = true
      this.replyInnerComNull = true;
    },
    editCommentReply(repcomment, comment) {
      this.commentItems.forEach((element) => {
        element.replyCommentLists.forEach((item) => {
          item.showInside_ReplyBox = false;
          item.showEditReplyBox = false;
          item.tempEditReplyText = "";
        });
      });

      this.commentItems[comment.no - 1].replyFlag = true;
      this.commentItems[comment.no - 1].replyCommentLists[
        repcomment.no - 1
      ].showEditReplyBox = true;
      this.commentItems[comment.no - 1].replyCommentLists[
        repcomment.no - 1
      ].tempEditReplyText = repcomment.replyMessage;
      this.editReplyNull = repcomment.replyMessage.length === 0;
    },
    cancelComment(com) {
      com.editCommentFlag = false;
    },
    ClickCommentReply(comment) {
      this.commentItems.forEach((element) => {
        element.editCommentFlag = false;
        element.replyFlag = false;
        element.showOuterCommentBox = false;
        element.tempReplyMsg = "";
        element.replyCommentLists.forEach((item) => {
          item.showInside_ReplyBox = false;
          item.showEditReplyBox = false;
          item.tempEditReplyText = "";
          item.tempCommentReplyMsg = "";
        });
      });

      this.commentItems[comment.no - 1].showOuterCommentBox = true;
      this.replyCommentNull = true;
    },
    editComment(com) {
      this.commentItems.forEach((element) => {
        element.editCommentFlag = false;
        element.replyFlag = false;
        element.showOuterCommentBox = false;
        element.replyCommentLists.forEach((item) => {
          item.showInside_ReplyBox = false;
          item.showEditReplyBox = false;
          item.tempEditReplyText = "";
          item.tempCommentReplyMsg = "";
        });
      });

      this.commentItems[com.no - 1].editCommentFlag = true;
      this.commentItems[com.no - 1].tempComment = com.commentMessage;
      this.commentNull = com.commentMessage.length === 0;
      com.editCommentFlag = true;
    },
    showReplylist(comment) {
      comment.replyFlag = !comment.replyFlag;
    },
    checkCommentLength(v, type) {
      if (v.length > 99) {
        alert("Message should be no more than 100 characters");
      }
      switch (type) {
        case 1:
          this.mainComNull = v.length === 0;
          break;
        case 2:
          this.commentNull = v.length === 0;
          break;
        case 3:
          this.replyCommentNull = v.length === 0;
          break;
        case 4:
          this.editReplyNull = v.length === 0;
          break;
        case 5:
          this.replyInnerComNull = v.length === 0;
          break;
      }
    },
    async GetCommentsForSound(contentID) {
      this.new_comment = "";
      await this.$axios
        .get(
          `${this.web_url}Comment/GetComments?VideoID=${contentID}&Page=${4}`
        )
        .then((res) => {
          if (res.data.data.length > 0) {
            this.commentItems = res.data.data.map((v, i) => ({
              ...v,
              no: i + 1,
              replyFlag: false,
              editCommentFlag: false,
              showOuterCommentBox: false,
              showOuterReplyBox: false,
              tempComment: "",
              tempReplyMsg: "",
              replyCommentLists: v.replyCommentLists.map((j, k) => ({
                ...j,
                no: k + 1,
                tempEditReplyText: "",
                tempCommentReplyMsg: "",
                showEditReplyBox: false,
                showInside_ReplyBox: false,
              })),
            }));
          } else {
            this.commentItems = [];
          }
        });
    },
    //............................... end of comment related..........................
    playPreviousSound() {
      this.nextPrevFlag = true;
      this.commentItems = [];
      this.$emit("skipToPrevious", this.playListOpt);
    },
    playNextSound() {
      this.nextPrevFlag = true;
      this.commentItems = [];
      this.callAddReportActivity();
      this.$emit("skipToNext", this.playListOpt);
    },
    Readnoti(notificationid, pageid) {
      const request = {
        userID: Number.parseInt(localStorage.getItem("UserID")),
        notificationID: notificationid,
        notiPage: pageid,
      };
      axios
        .post(`${this.web_url}Notification/AddUserIDinNotiJoin`, request)
        .then((result) => {
          if (result.data.status == 0) {
            this.getNotificationCount();
          }
        });
    },
    async getNotificationCount() {
      const request = {
        userId: Number.parseInt(localStorage.getItem("UserID")),
        companyId: localStorage.getItem("companyID"),
      };
      await axios
        .post(
          `${this.web_urlV3}Notification/GetAllNotificationMobileV4`,
          request
        )
        .then((result) => {
          if (result.data.status == 0) {
            const d1 = result.data.data.filter((x) => !x.viewOrNot).length;
            const d2 = result.data.data1.filter((x) => !x.newNoti).length;
            const d3 = result.data.data2.filter((x) => !x.newNoti).length;
            const d4 = result.data.data4.filter((x) => !x.newNoti).length;
            const d5 = result.data.data5.filter((x) => !x.newNoti).length;
            const d6 = result.data.data6.filter((x) => !x.newNoti).length;
            const d7 = result.data.data7.filter((x) => !x.newNoti).length;
            const d8 = result.data.data8.filter((x) => !x.newNoti).length;
            const d9 = result.data.data3.filter((x) => !x.newNoti).length;
            const notiCount = d1 + d2 + d3 + d4 + d5 + d6 + d7 + d8 + d9;
            this.$store.commit("savenotiCount", notiCount);
          }
        });
    },
    getFavorite(v) {
      this.Addfav = v;
    },
    cutText() {
      if (this.audioName.length <= this.maxlength) {
        return this.audioName;
      } else {
        return this.audioName.substring(0, this.maxlength) + "...";
      }
    },
    async closeSoundDialog() {
      this.exit_dialog = true;
      this.wavesurfer.pause();
    },

    PlayMP3(item) {
      const viewerFlag = this.viewerFlag;

      console.log("Rewind: ", this.viewerFlag);

      // If a player exists, destroy it and reset UI elements
      if (this.wavesurfer) {
        this.wavesurfer.destroy();
        this.audioDuration = "0:00";
        this.currentAudioTime = "0:00";
        this.showMp3Player = false;
      }

      // Initialize the new audio player
      this.wavesurfer = WaveSurfer1.create(this.wavesurferOptions);
      this.wavesurfer.load(item);
      this.startLoadingAudio = true;

      // Initialize flags and states
      this.currentPosition = 0;
      this.userSeeking = false;
      this.alertVisible = false;
      this.audioPlayed = false;

      // Check if the audio was previously played
      const previousPlayedStatus = localStorage.getItem(`audioPlayed_${item}`);
      if (previousPlayedStatus === "true") {
        this.audioPlayed = true;
      }

      // On audio ready, set up the initial play state
      this.wavesurfer.on("ready", () => this.handleWaveformReady());

      // Audio loading progress
      this.wavesurfer.on("loading", (percent) =>
        this.handleWaveformLoading(percent)
      );

      // Update current audio time and position
      this.wavesurfer.on("audioprocess", () =>
        this.handleWaveformAudioProcess()
      );

      // Handle user seeking and prevent skipping
      const handleUserSeeking = () => {
        this.userSeeking = true;
        clearTimeout(this.seekTimeout);
        this.seekTimeout = setTimeout(() => {
          this.userSeeking = false;
        }, 100);
      };

      // Attach events to prevent skipping during seek
      this.wavesurfer.drawer.container.addEventListener(
        "mousedown",
        handleUserSeeking
      );
      this.wavesurfer.drawer.container.addEventListener(
        "mouseup",
        handleUserSeeking
      );

      // Prevent seeking if not allowed (when viewerFlag is false)
      this.wavesurfer.on("seek", (progress) =>
        this.handleWaveformSeek(progress, viewerFlag)
      );

      // Handle play events and track view time
      this.wavesurfer.on("play", () => this.handleWaveformPlay(item));

      // Pause event (clear intervals)
      this.wavesurfer.on("pause", () => this.handleWaveformPause());

      // When audio finishes, show complete dialog
      this.wavesurfer.on("finish", () => this.handleWaveformFinish(item));

      // Handle window unload events
      globalThis.addEventListener("beforeunload", (event) =>
        this.handleBeforeUnload(event)
      );

      // Cleanup when wavesurfer is destroyed
      this.wavesurfer.on("destroy", () => this.handleWaveformDestroy());
    },

    // On audio ready, set up the initial play state
    handleWaveformReady() {
      const desiredTime = this.currentminutes || 0;
      const position = this.nextPrevFlag
        ? 0
        : desiredTime / this.wavesurfer.getDuration();
      this.wavesurfer.seekTo(position);
      this.wavesurfer.play();

      this.audioDuration = this.formatTimeNew(this.wavesurfer.getDuration());
    },

    // Audio loading progress
    handleWaveformLoading(percent) {
      this.power = percent;
      if (percent === 100) {
        this.playAudio();
        this.startLoadingAudio = false;
        this.showMp3Player = true;
      }
    },

    // Update current audio time and position
    handleWaveformAudioProcess() {
      this.currentAudioTime = this.formatTimeNew(
        this.wavesurfer.getCurrentTime()
      );
      this.currentPosition = this.wavesurfer.getCurrentTime();
    },

    // Prevent seeking if not allowed (when viewerFlag is false)
    handleWaveformSeek(progress, viewerFlag) {
      if (!viewerFlag && this.userSeeking) {
        const newPosition = progress * this.wavesurfer.getDuration();
        if (Math.abs(newPosition - this.currentPosition) > 1) {
          this.wavesurfer.seekTo(
            this.currentPosition / this.wavesurfer.getDuration()
          );
          if (!this.alertVisible) {
            this.showAlertMessage = true;
            this.alertVisible = true;
          }
        }
      }
    },

    // Handle play events and track view time
    handleWaveformPlay(item) {
      this.startMediaActivity(); // F06 DSD
      this.intervalId = setInterval(() => {
        this.actualViewTime += 1;

        if (this.actualViewTime >= this.wavesurfer.getDuration()) {
          clearInterval(this.intervalId);
          this.audioPlayed = true;
          localStorage.setItem(`audioPlayed_${item}`, "true");

          if (this.alertVisible) {
            this.showAlertMessage = false;
            this.alertVisible = false;
          }
        }
      }, 1000);
    },

    // Pause event (clear intervals)
    handleWaveformPause() {
      this.stopMediaActivity(); // F06 DSD
      clearInterval(this.intervalId);
    },

    // When audio finishes, show complete dialog
    handleWaveformFinish(item) {
      this.stopMediaActivity(); // F06 DSD
      this.showPlay = true;
      this.complete_dialog = true;
      this.audioPlayed = true;
      localStorage.setItem(`audioPlayed_${item}`, "true");

      if (this.alertVisible) {
        this.showAlertMessage = false;
        this.alertVisible = false;
      }
    },

    // Handle window unload events
    handleBeforeUnload(event) {
      if (!this.audioPlayed) {
        this.showAlertMessage = true;
        this.alertVisible = true;
        event.preventDefault();
        event.returnValue = "";
      }
    },

    // Cleanup when wavesurfer is destroyed
    handleWaveformDestroy() {
      this.stopMediaActivity(); // F06 DSD
      if (this.alertVisible) {
        this.showAlertMessage = false;
        this.alertVisible = false;
      }
    },

    // F06 DSD — ฟังเสียงนับเป็น activity (Q-T1 = ก)
    startMediaActivity() {
      this.notifyMediaActivity();
      if (this.mediaActivityTimer) return;
      this.mediaActivityTimer = setInterval(() => {
        if (this.show && this.wavesurfer && this.wavesurfer.isPlaying()) this.notifyMediaActivity();
      }, 30000);
    },
    stopMediaActivity() {
      clearInterval(this.mediaActivityTimer);
      this.mediaActivityTimer = null;
    },

    clickPlayBtn(value) {
      this.nextPrevFlag = !value;
    },
    async callAddReportActivity() {
      let actualview_time = this.actualViewTime.toString();
      const currentTime = this.convertToSeconds(this.currentAudioTime);
      const duration = this.convertToSeconds(this.audioDuration);
      if (this.actualViewTime === 0) {
        console.log("hello next sound");
      } else {
        let temp = currentTime / duration;
        if (temp.toFixed(1) == "1.0") {
          this.progress_time = Number.parseFloat(temp) - 0.1;
          this.progress_time = this.progress_time.toFixed(1);
        } else {
          this.progress_time = temp.toFixed(1);
        }

        const request = {
          userID: Number.parseInt(localStorage.getItem("UserID")),
          id: this.contentid,
          minutes: currentTime.toString(),
          separatePage: 4,
          progressTime: this.progress_time,
          actualViewTime: actualview_time,
        };

        axios
          .post(`${this.web_url}Reports/AddReportActivity`, request)
          .then((res) => {
            if (res.data.status === 0) {
              this.$emit("updateProgressCircle", request);
            } else {
              console.error("Failed to save user activity report");
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    async exitPlayer() {
      this.$emit("updateNotiReadStatusColor"); // to change noti box color after checked.
      let actualview_time = this.actualViewTime.toString();
      const currentTime = this.convertToSeconds(this.currentAudioTime);
      const duration = this.convertToSeconds(this.audioDuration);

      if (this.actualViewTime === 0) {
        this.exit_dialog = false;
        this.showPlay = true;
        this.dialog = false;
      } else {
        let temp = currentTime / duration;
        if (temp.toFixed(1) == "1.0") {
          this.progress_time = Number.parseFloat(temp) - 0.1;
          this.progress_time = this.progress_time.toFixed(1);
        } else {
          this.progress_time = temp.toFixed(1);
        }

        const request = {
          userID: Number.parseInt(localStorage.getItem("UserID")),
          id: this.contentid,
          minutes: currentTime.toString(),
          separatePage: 4,
          progressTime: this.progress_time,
          actualViewTime: actualview_time,
        };

        axios
          .post(`${this.web_url}Reports/AddReportActivity`, request)
          .then((res) => {
            if (res.data.status === 0) {
              this.$emit("updateProgressCircle", request);
              this.exit_dialog = false;
              this.actualViewTime = 0;
              this.showPlay = true;
              this.dialog = false;
            } else {
              console.error("Failed to save user activity report");
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },

    formatTimeNew(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60)
        .toString()
        .padStart(2, "0");
      return `${minutes}:${seconds}`;
    },
    formatTime(t_seconds) {
      const minutes = Math.floor(t_seconds / 60);
      const remainingSeconds = (t_seconds % 60).toFixed(1);
      return `${minutes}:${remainingSeconds.padStart(4, "0")}`;
    },
    convertToSeconds(timeString) {
      const [minutes, seconds] = timeString.split(":").map(Number.parseFloat);
      return minutes * 60 + seconds;
    },
    playAudio() {
      this.wavesurfer.play();
      this.showPlay = false;
    },

    pauseAudio() {
      this.wavesurfer.pause();
      this.showPlay = true;
    },

    toggleCheck() {
      this.Addfav = !this.Addfav;
      this.updateFavourite(this.Addfav);
    },
    updateFavourite(isFavourite) {
      const request = {
        userID: Number.parseInt(localStorage.getItem("UserID")),
        contentID: this.contentid,
        contentCheck: 2,
        favFlag: isFavourite,
      };
      axios
        .post(`${this.web_url}Contents/UpdateFavorite`, request)
        .then((res) => {
          if (res.data.status == 0) {
            if (isFavourite === true) {
              this.$store.commit(
                "savefavCount",
                this.$store.state.library.favCount + 1
              );
            } else {
              this.$store.commit(
                "savefavCount",
                this.$store.state.library.favCount - 1
              );
            }
          }
        });
    },
    viewComplete() {
      this.$emit("updateNotiReadStatusColor"); // to change noti box color after checked.
      // Stop the view time tracking timer
      let actualview_time = this.actualViewTime.toString();
      const [minutes, seconds] = this.currentAudioTime
        .split(":")
        .map(Number.parseFloat);
      const minute_data = minutes * 60 + seconds;
      const request = {
        userID: Number.parseInt(localStorage.getItem("UserID")),
        id: this.contentid,
        minutes: minute_data.toString(),
        separatePage: 4,
        progressTime: "1",
        actualViewTime: actualview_time,
      };

      axios
        .post(`${this.web_url}Reports/AddReportActivity`, request)
        .then((res) => {
          if (res.data.status === 0) {
            this.$emit("updateProgressCircle", request);
            this.complete_dialog = false;
            this.exit_dialog = false;
            this.dialog = false;
            this.actualViewTime = 0;
          } else {
            console.error("Failed to save user activity report");
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    cancelExitPlayer() {
      this.exit_dialog = false;
      this.dialog = true;
      this.showPlay = false;
      this.$emit("show_sound");
      this.wavesurfer.play();
    },
  },
};
</script>

<style scoped>
.v-btn:not(.v-btn--round).v-size--default {
  padding: unset;
}

.play-back-btn {
  background-color: white !important;
  border-radius: 8px;
  width: 37px;
  min-width: 37px !important;
  height: 37px !important;
  padding-left: 7px !important;
  margin-right: 1rem !important;
}

.play-next-btn {
  background-color: white !important;
  border-radius: 8px;
  width: 37px;
  min-width: 37px !important;
  height: 37px !important;
  padding-left: 8px !important;
  margin-left: 0.5rem !important;
}

.test {
  display: flex;
  justify-content: center;
}

.border1 {
  height: 1px;
  width: 95%;
  background-color: #00000027;
}

.lessonimg {
  width: 192px !important;
  height: 130px !important;
  border-radius: 12px;
}

.lessonTitle {
  font-size: 20px;
  margin-bottom: 15px;
}

.lessonDes {
  font-size: 14px;
  opacity: 0.6;
}

.lessonIcon {
  margin-left: 20px;
  color: #4fb14e;
  font-size: 40px;
  top: 10px;
  position: absolute;
}

::v-deep .audioPhoto {
  object-fit: cover;
  border-radius: 16px;
}

/* .btn_hover_effect rules moved below to the shared "comment section css"
   style block, where they are merged with the identical .reset-btn rules
   to avoid a duplicated selector (css:S4666). */
</style>
<!-- comment section css -->
<style scoped>
.audioTitle-font {
  font-size: 28px;
  color: #424242;
}

.comment-paddingLeft4 {
  padding-left: 16px !important;
}

.marginRight-6 {
  margin-right: 24px !important;
}

.reply-textbox-paddingLeft {
  padding-left: 60px !important;
}

::v-deep .primary--text {
  color: #a6cc39 !important;
  caret-color: #a6cc39 !important;
}

::v-deep .comment-textbox {
  color: #a6cc39 !important;
  caret-color: #a6cc39 !important;
}

.btn_hover_effect,
.reset-btn {
  color: #fff;
  width: 80%;
  font-size: 14px;
  z-index: 0;
  position: relative;
  display: inline-block;
}

.btn_hover_effect:before,
.reset-btn:before {
  background-color: #4fb14e;
  content: "";
  display: block;
  position: absolute;
  top: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  opacity: 0.5 !important;
  -webkit-transition: all 0.35s ease;
  transition: all 0.35s ease;
}

.btn_hover_effect:hover:before,
.reset-btn:hover:before {
  background-color: #4fb14e;
  top: 0;
}

.btn_hover_effect:hover,
.reset-btn:hover {
  transition: 0.25s;
}

.btn_hover_effect:after,
.reset-btn:after {
  position: absolute;
  right: 2.34375rem;
  top: 50%;
  -webkit-transform: translateY(-50%) translateX(50%);
  -ms-transform: translateY(-50%) translateX(50%);
  transform: translateY(-50%) translateX(50%);
}

::v-deep .v-dialog {
  overflow-x: hidden;
  overflow-y: hidden;
}

.scrollbar-container {
  height: auto;
  padding: 0 0 1rem 0;
}

.video-scrollbar {
  padding: 0 2.4rem 0 1.7rem;
  height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
}

@media screen and (max-width: 768px) {
  .scrollbar-container {
    padding-right: 5px;
    height: auto;
    padding-bottom: 1rem;
    padding-left: 0px;
  }

  .video-scrollbar {
    padding-bottom: 2rem;
    height: 30vh;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
  }
}

@media only screen and (max-width: 600px) {
  .audioTitle-font {
    font-size: 16px;
    color: #424242;
  }

  .videoTitle-font {
    font-size: 12px !important;
  }

  .marginRight-6 {
    margin-right: 5px !important;
  }

  .reply-textbox-paddingLeft {
    padding-left: 0px !important;
  }

  .comment-paddingLeft4 {
    padding-left: 10px !important;
  }

  .video-scrollbar {
    padding: 0;
    height: 25vh;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
  }
}
</style>
